export const StatisticsIcon = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.16669 7.08602H4.66669V11.7527H1.16669V7.08602ZM5.25002 1.25269H8.75002V11.7527H5.25002V1.25269ZM9.33335 4.16935H12.8334V11.7527H9.33335V4.16935Z"
                fill="currentColor"
            />
        </svg>
    );
};
